// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"185":"78d32fb5861ca70d","296":"00d274213f18881d"}[chunkId] + ".js";
};